//rfce
import React, { useState, useEffect } from 'react';
import TodoForm from './TodoForm';
import Todo from './Todo';
import DateSnippet from './DateSnippet';

function TodoList() {
    const [todos, setTodos] = useState(() => {
        // get the todos from localstorage
        const savedTodos = localStorage.getItem("todos");
        // if there are todos stored
        if (savedTodos) {
            // return the parsed the JSON object back to a javascript object
            return JSON.parse(savedTodos);
            // otherwise
        } else {
            // return an empty array
            return [];
        }
    });

    // useEffect to run once the component mounts
    useEffect(() => {
        // localstorage only support storing strings as keys and values
        // - therefore we cannot store arrays and objects without converting the object
        // into a string first. JSON.stringify will convert the object into a JSON string
        localStorage.setItem("todos", JSON.stringify(todos));
        // add the todos as a dependancy because we want to update
        // localstorage anytime the todos state changes
    }, [todos]);

    const addTodo = todo => {
        if (!todo.text || /^\s*$/.test(todo.text)) return;

        const newTodos = [todo, ...todos];
        setTodos(newTodos);
        console.log(...todos);
    };

    const removeTodo = (todoId) => {
        const removeArray = [...todos].filter(todo => todo.id !== todoId);
        setTodos(removeArray);
    };

    const completeTodo = todoId => {
        let updatedTodos = todos.map(todo => {
            if (todo.id === todoId) todo.isComplete = !todo.isComplete;
            return todo;
        });

        setTodos(updatedTodos);
    };

    const updateTodo = (todoId, newValue) => {
        if (!newValue.text || /^\s*$/.test(newValue.text))
            return;

        setTodos(previous => previous.map(item => (item.id === todoId ? newValue : item)));
    };


    return (
        <div>
            <p style={{ textAlign: 'right', paddingRight: '20px', paddingTop: '14px', color: 'lightGrey', letterSpacing: '1px' }}><DateSnippet /></p>
            <h1>Today's Tasks </h1>
            <TodoForm onSubmit={addTodo} />
            <Todo
                todos={todos}
                completeTodo={completeTodo}
                removeTodo={removeTodo}
                updateTodo={updateTodo}
            />
        </div>
    );
}

export default TodoList;
